// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1cbvz","addWidgetButton":"Header_addWidgetButton__2e-Vw","dashboardTabs":"Header_dashboardTabs__2i2g1","active":"Header_active__1_IiL"};